import { render, staticRenderFns } from "./StakingCurrencies.vue?vue&type=template&id=53602e66&scoped=true&"
import script from "./StakingCurrencies.vue?vue&type=script&lang=js&"
export * from "./StakingCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./StakingCurrencies.vue?vue&type=style&index=0&id=53602e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53602e66",
  null
  
)

export default component.exports